export default __webpack_public_path__ + "static/media/physical.3af186a9.png";